import ISTQBAIDemoQuiz from './istqb_ai_demo_quiz';
import ISTQBAIFullQuiz from './istqb_ai_full_quiz';
// @ts-ignore
import AITesterLanding from './quiz_landing';
import UnsubscribePage from './UnsubscribePage';

export default function App() {
  const handleBuyFullVersion = () => {
    window.open('https://ainastasia.gumroad.com/l/quiz?wanted=true', '_blank');
  };

  // Simple URL-based routing - support both path and hash routing
  const path = window.location.pathname;
  const hash = window.location.hash;
  const showDemoQuiz = path.includes('/demoquiz') || path.includes('/demo') || hash.includes('/demoquiz') || hash.includes('/demo');
  const showFullQuiz = path.includes('/your-quiz') || path.includes('/fullquiz') || hash.includes('/your-quiz') || hash.includes('/fullquiz');
  const showUnsubscribe = path.includes('/unsubscribe') || hash.includes('/unsubscribe') || hash.includes('#unsubscribe');
  
  // Debug log for routing - enhanced for debugging
  console.log('🛣️ ROUTING DEBUG:', { 
    path, 
    hash, 
    showDemoQuiz, 
    showFullQuiz, 
    showUnsubscribe,
    pathname: window.location.pathname,
    href: window.location.href,
    search: window.location.search,
    timestamp: new Date().toISOString()
  });
  
  // Force debug info to DOM for production debugging
  if (typeof window !== 'undefined') {
    (window as any).__ROUTING_INFO__ = {
      path,
      hash,
      showUnsubscribe,
      UnsubscribePageImported: !!UnsubscribePage,
      timestamp: new Date().toISOString()
    };
  }

  if (showUnsubscribe) {
    return <UnsubscribePage />;
  }

  if (showDemoQuiz) {
    return <ISTQBAIDemoQuiz onBuyFullVersion={handleBuyFullVersion} />;
  }

  if (showFullQuiz) {
    return <ISTQBAIFullQuiz onBuyFullVersion={handleBuyFullVersion} />;
  }

  // Default: show landing page
  return <AITesterLanding />;
}